import * as THREE from 'three';

type TextureImageLike = {
  width?: number;
  height?: number;
  data?: ArrayLike<number> | ArrayBuffer | null;
};

/** True when a THREE.Texture has pixel data WebGL can upload. */
export function isTextureUploadReady(texture: THREE.Texture | null | undefined): boolean {
  if (!texture) {
    return false;
  }

  const image = texture.image as TextureImageLike | undefined;
  if (!image) {
    return false;
  }

  if (
    typeof image.width === 'number'
    && image.width > 0
    && typeof image.height === 'number'
    && image.height > 0
  ) {
    return true;
  }

  const data = image.data;
  if (data && typeof (data as ArrayLike<number>).length === 'number' && (data as ArrayLike<number>).length > 0) {
    return true;
  }

  return false;
}
